// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__8QWkU","form":"styles_form__6YfSJ"};